import type { ValidationIssue } from '@royaltyflow/validation';
import { REASONS, issue } from '../lib/csvValidation';
import { errorDetails, errorMessage } from '../lib/errors';

export function validationIssues(error: unknown): ValidationIssue[] {
  const details = errorDetails(error);
  if (Array.isArray(details?.issues)) {
    const issues = details.issues.filter(
      (value): value is ValidationIssue =>
        value !== null &&
        typeof value === 'object' &&
        REASONS.includes(value.reason) &&
        typeof value.message === 'string' &&
        typeof value.path === 'string',
    );
    if (issues.length) return issues;
  }
  return [issue('invalid_value', errorMessage(error), 'request', '')];
}

export function ValidationIssuePanel({ issues }: { issues: readonly ValidationIssue[] }) {
  if (!issues.length) return null;
  const groups = new Map<string, ValidationIssue[]>();
  issues.forEach((item) => {
    const name = item.source?.fileName ?? item.source?.importId ?? item.entity;
    groups.set(name, [...(groups.get(name) ?? []), item]);
  });
  return (
    <section className="rfp-validation-panel" role="alert" aria-label="Validation errors">
      <p>
        <strong>Resolve these errors before continuing</strong>
      </p>
      {Array.from(groups.entries()).map(([name, items]) => (
        <div key={name}>
          <strong>{name}</strong>
          <ul className="rfp-error-list">
            {items.map((item, index) => (
              <li key={`${item.reason}-${item.entityId ?? ''}-${item.path}-${index}`}>
                {item.source && (
                  <span>
                    CSV row {item.source.record ?? 'unknown'}, line {item.source.lineStart}
                    {item.source.lineEnd !== item.source.lineStart ? `–${item.source.lineEnd}` : ''}
                    :{' '}
                  </span>
                )}
                {item.entityId && !item.source && (
                  <span>
                    {item.entity} {item.entityId}:{' '}
                  </span>
                )}
                {item.path && <strong>{item.path} — </strong>}
                {item.message} <small>({item.reason})</small>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
